export enum MimeType {
  JSON = 'application/json'
}
